import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import AppSnackbar from "components/common/AppSnackbar";

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const [queue, setQueue] = useState([]);
  const nextId = useRef(0);

  const notify = useCallback((message, severity = "info") => {
    if (!message) return;
    const id = ++nextId.current;
    setQueue((current) => [...current, { id, message, severity }]);
  }, []);

  const closeCurrent = useCallback(() => {
    setQueue((current) => current.slice(1));
  }, []);

  const value = useMemo(() => ({ notify }), [notify]);
  const current = queue[0];

  return (
    <NotificationContext.Provider value={value}>
      {children}
      {current && (
        <AppSnackbar
          key={current.id}
          open
          message={current.message}
          severity={current.severity}
          onClose={closeCurrent}
        />
      )}
    </NotificationContext.Provider>
  );
}

NotificationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useNotificationContext() {
  return useContext(NotificationContext);
}
